import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import ScenarioQuestionformat from "../../../Student/Reusablecomponents/ScenarioQuestionformat";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { QuestionData } from "../../../Redux/Reducers/QBAdmin/EditQuestions";
import { ScenarioData } from "../../../Redux/Reducers/QBAdmin/Editscenario";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
import ScenarioDelete from "../../../ReusableComponents/CommonApis";
import { PaginationData } from "../../../Redux/Reducers/Common/Pagination";
import {
  ViewVerificationQStatus,
  QuestionDelete,
  QuestionPreview,
  GetEnglishScenarioDetails,
  GetEnglishQuestionDetails,
  ViewQuestionStatus,
} from "../../../ReusableComponents/CommonApis";
import Search from "../../../ReusableComponents/Search";
import axiosInstance from "../../../ReusableComponents/Axios";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import { LoadContext } from "../../../ReusableComponents/LoadingContex";
import { FaClockRotateLeft } from "react-icons/fa6";
const HInputBasedQuestions = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const [NSBased, SetNSBased] = useState(
    localStorage.getItem("IBQF") || props.SType || "SCDISQ"
  );
  const PagnatioNumber = useSelector((state) => state.PaginationNo);
  const { SetLoad } = useContext(LoadContext);
  const [IBQuestions, SetIBQuestions] = useState(props.data);
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(1);
  const [StatusData, SetStatusData] = useState();
  const [QuestionsData, SetQuestionData] = useState();
  const [SearchText, SetSearchText] = useState(NSBased === "NONSCDISQ" ? localStorage.getItem("SearchQINQId") || "" : localStorage.getItem("SearchSINQId") || "");
  const [DMessage, SetDMessage] = useState();

  useEffect(() => {
    const PNumber =
      PagnatioNumber?.Location === location.pathname &&
      PagnatioNumber?.TableName === NSBased &&
      PagnatioNumber?.PageNumber;

    if (SearchText?.length > 0) {
      GetFilterDetails();
    } else
      if (!props.data) {
        if (NSBased === "SCDISQ") {
          GetQuestiuons(PNumber || CPage);
        } else {
          GetNONSQuestiuons(PNumber || CPage);
        }
      }
  }, [PageCount, NSBased, DMessage]);

  const ScenarioBased = [
    {
      name: "Scenario ID",
      selector: "scenarioID",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          onClick={() => AddEditScenario(row)}
          title="Edit Scenario"
        >
          {row.scenarioID}{" "}
        </div>
      ),
    },
    {
      name: "Scenario",
      selector: "scenarioName",
      sortable: true,
      cell: (row) => (
        <div className="ScenarioList">
          <ScenarioQuestionformat scenario={row.scenarioName} />{" "}
        </div>
      ),
    },
    {
      name: "Main Source",
      selector: "mainSourceLovId",
      sortable: true,
      cell: (row) => (
        <div>
          {row.mainSourceLovId === 3543
            ? "Text book based"
            : "Non-text book based"}{" "}
        </div>
      ),
    },
    {
      name: "Questions",
      cell: (row) => (
        <div
          className="dflex CPointer JCCenter gap-2 alignitems"
        >
          <div className=" dflex alignitems gap-1">
            <FaRegEye
              title="View Questions in Scenario"
              onClick={() => NavigateQuestions(row)}
              style={{ color: "#624DE3" }}
            />{" "}
            ({row?.questionCount}){" "}
          </div>
          <RiDeleteBin5Line
            style={{ color: "#FD3333" }}
            onClick={() => DeleteScenario(row)}
          />{" "}
        </div>
      ),
    },
  ];
  const AddEditScenario = (Row) => {
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchSINQId", SearchText);
    }
    GetEnglishScenarioDetails(
      Row.scenarioID,
      dispatch,
      navigate,
      SetLoad,
      location,
      true
    );
    // dispatch(ScenarioData({ ScenarioDetails: Row }));
    // navigate("/QBAdmin/QuestionBank/AddEditScenario");
  };
  const DeleteScenario = async (Row) => {
    if (Row.questionCount > 0) {
      alert(
        "Please delete all questions associated with the scenario before you could delete the scenario"
      );
    } else {
      if (window.confirm("Are you sure you want to delete the scenario ?")) {
        ScenarioDelete(Row.scenarioID, dispatch, GetQuestiuons(1));
      }
    }
  };

  const NavigateQuestions = (Row) => {
    dispatch(ScenarioData({ ScenarioDetails: Row }));
    navigate("/QBAdmin/QuestionBank/ScenarioQuestions", {
      state: { Tab: location.state.Tab },
    });
  };
  const HandleQuestionDetails = (Qid) => {
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchQINQId", SearchText);
    }
    localStorage.setItem("ERCG",false);
    GetEnglishQuestionDetails(Qid, dispatch, navigate, SetLoad, location, true);
  };
  const NONScenarioBased = [
    {
      name: "Question No(Id)",
      selector: "questionID",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          title="Edit Question"
          onClick={() => HandleQuestionDetails(row.questionID)}
        >
          {row.questionID}{" "}
        </div>
      ),
    },
    {
      name: "Question",
      selector: "question",
      cell: (row) => (
        <div className="ScenarioList">
          <ScenarioQuestionformat scenario={row.question} />
        </div>
      ),
    },
    {
      name: "Answer(s)",
      selector: "answer",
      sortable: true,
      cell: (row) => (
        <div className="dflex">
          <ScenarioQuestionformat scenario={row.answer} />
        </div>
      ),
    },
    {
      name: "Question Verification Status",
      selector: "qbStatus",
      sortable: true,
      cell: (row) => (
        <div className="dflex flexd-column">
          <span>{row.qbStatus}</span>
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetStatusData(row.questionID)}
          >
            {" "}
            View Status Log{" "}
          </span>
        </div>
      ),
    },
    {
      name: "Used/Unused - Mapped/UnMapped",
      selector: "qStatus",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="dflex CPointer alignitems JCCenter gap-2" >
          <FaRegEye
            title="Preview"
            onClick={() => {
              if (SearchText?.length > 0) {
                localStorage.setItem("SearchQINQId", SearchText);
              }
              QuestionPreview(row, dispatch, navigate, location, true)
            }
            }
          />
          <RiDeleteBin5Line
            style={{ color: "#FD3333" }}
            onClick={() =>
              QuestionDelete(row.questionID, SetDMessage, dispatch, location)
            }
          />{" "}
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetQuestionData(row.questionID)}
            title="View Question Activity Log"
          >
            <FaClockRotateLeft />
          </span>
        </div>
      ),
    },
  ];

  const GetNONSQuestiuons = async (PageNo) => {
    SetCPage(PageNo);
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/GetNonScenarioQuestions?SubjectId=${items?.subjectId}&PageNo=${PageNo}&PageSize=${PageCount}&Filter=0&QBCategoryType=${NSBased}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.questionID) {
          SetIBQuestions(res.data);
        } else {
          SetIBQuestions(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  const GetQuestiuons = async (PageNo) => {
    SetCPage(PageNo);
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetLanguageScenarios?SubjectId=${items?.subjectId}&PageNo=${PageNo}&PageSize=${PageCount}&IsUsedOrMapped=0&QBCategoryType=${NSBased}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.scenarioID) {
          SetIBQuestions(res.data);
        } else {
          SetIBQuestions(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  const IBAUQuestions = () => {
    dispatch(ScenarioData({ ScenarioDetails: "" }));
    localStorage.setItem("IBQF", NSBased);
    if (NSBased === "SCDISQ") {
      navigate("/QBAdmin/QuestionBank/AddEditScenario", {
        state: { Tab: location.state.Tab },
      });
    } else {
      dispatch(QuestionData({ QuestionDetails: "" }));
      navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
        state: { Tab: location.state.Tab },
      });
    }
  };

  const handleSNSBased = (e) => {
    SetSearchText([]);
    SetNSBased(e);
    localStorage.setItem("IBQF", e);
    dispatch(
      PaginationData({
        Location: location.pathname,
        TableName: e,
        PageNumber: 1,
      })
    );
    // setSearchParams({ ...Object.fromEntries(searchParams), e });
  };

  const GetFilterDetails = () => {
    if (NSBased === "NONSCDISQ") {
      GetsearchQuestionId();
    } else {
      SearchByScenarioId();
    }
  };
  const BacktoNormaList = () => {
    SetSearchText([]);
    localStorage.removeItem("SearchSINQId");
    localStorage.removeItem("SearchQINQId");
    if (NSBased === "NONSCDISQ") {
      GetNONSQuestiuons(CPage);
    } else {
      GetQuestiuons(CPage);
    }
  };
  const SearchByScenarioId = async () => {
    SetLoad((prev) => !prev);

    try {
      const res = await axiosInstance.get(
        `/Scenario/GetInputBasedScenarioByIds?SubjectId=${items?.subjectId}&ScenarioId=${SearchText}&LanguageId=${SelectLanguage}`
      );
      if (res.data[0]?.scenarioID) {
        SetIBQuestions(res.data);
      } else {
        SetIBQuestions(process.env.REACT_APP_NODATAFOUND);
      }
      SetLoad((prev) => !prev);
    } catch (err) {
      SetLoad((prev) => !prev);
      notify("Please enter valid input", "warning");
    }
  };

  const GetsearchQuestionId = async () => {
    if (SearchText.length > 0) {
      SetLoad((prev) => !prev);
      try {
        const res = await axiosInstance.get(
          `/QuestionBank/GetFilterQuestionByQuestionId?QuestionId=${SearchText}&SubjectId=${items?.subjectId}&LanguageId=${SelectLanguage}`
        );
        SetIBQuestions(res.data);
        SetLoad((prev) => !prev);
      } catch (err) {
        console.log(err);
      }
    } else {
      notify("Please enter the atlest one Question Id", "warning");
    }
  };
  return (
    <>
      {!props.data && <div className="MainHeading">Input based Questions</div>}
      {!props.data && (
        <div className="dflex JCCenter gap-3">
          {["SCDISQ", "NONSCDISQ"].map((Item) => (
            <div key={Item} className="dflex alignitems gap-2">
              <input
                type="Radio"
                value={Item}
                name="NSBased"
                checked={NSBased === Item}
                onChange={(e) => handleSNSBased(e.target.value)}
              />{" "}
              {Item === "SCDISQ" ? "Scenario Based" : "Non Scenario Based"}
            </div>
          ))}
        </div>
      )}
      <div className="Card mt-2">
        <div className="dflex JSBetween alignitems InputFIlters m-1">
          <label style={{ backgroundColor: "white" }}>Search</label>

          <div>
            By {NSBased === "NONSCDISQ" ? "Question" : "Scenario"} Id(s){" "}
          </div>

          <Search
            Searchvalue={SearchText}
            placeholder={`Enter ${NSBased === "NONSCDISQ" ? "Question" : "Scenario"
              } Id(s)`}
            onChange={(e) => SetSearchText(e.replace(/[^0-9,]/g, ""))}
          />

          <div className="dflex alignitems gap-2">
            <button className="Buttons" onClick={GetFilterDetails}>
              {" "}
              Go{" "}
            </button>
            <button className="Buttons" onClick={BacktoNormaList}>
              {" "}
              Clear Filters{" "}
            </button>
          </div>
        </div>
      </div>
      <div className="dflex mt-3 mb-2 alignitems JSBetween">
        <div className="SubHeading">
          {" "}
          {NSBased === "SCDISQ" ? " Scenarios" : "Questions"}
        </div>
        <button className="Buttons AddButton dflex alignitems JCCenter" onClick={IBAUQuestions}>
          <HiMiniPlusSmall /> Add{" "}
          {NSBased === "SCDISQ" ? "Scenario" : "Question"}{" "}
        </button>
      </div>

      <div className="Card mt-2">
        {IBQuestions?.[0]?.scenarioID || IBQuestions?.[0]?.questionID ? (
          <DataTable
            data={IBQuestions}
            columns={
              (props.SType || NSBased) === "SCDISQ"
                ? ScenarioBased
                : NONScenarioBased
            }
            className="NCLDataTable"
            TotalRecords={
              (props.SType || NSBased) === "SCDISQ"
                ? IBQuestions[0]?.totalScenario
                : IBQuestions[0]?.totalQuestions
            }
            CountPage={SetPageCount}
            NoPage={CPage}
            tablename={NSBased}
            Dropdownvalues={["10", "25", "50", "100"]}
            ShowPagination="true"
            ShowPagecount="true"
            hitapi={(e) => {
              if (NSBased === "SCDISQ") {
                GetQuestiuons(e);
              } else {
                GetNONSQuestiuons(e);
              }
            }}
          />
        ) : (
          <div className="ErrorMessage">{IBQuestions}</div>
        )}
      </div>

      {DMessage?.open && (
        <div className="Model-Open">
          <div className="Card w-50">
            {" "}
            {DMessage?.message}
            <button
              className="Buttons"
              style={{ float: "right" }}
              onClick={() => {
                SetDMessage({ open: false });
              }}
            >
              ok
            </button>
          </div>
        </div>
      )}

      {StatusData && (
        <ViewVerificationQStatus QId={StatusData} Close={SetStatusData} />
      )}
      {QuestionsData && (
        <ViewQuestionStatus QId={QuestionsData} Close={SetQuestionData} />
      )}
    </>
  );
};
export default HInputBasedQuestions;
